import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'app/components/Button';
import * as FormActions from 'app/actions/form/actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ReduxActions } from 'app/actions';
import { Grid } from '@mui/material';
import { productsSelector } from 'app/reducers/app-config';
import { getFormType } from "../../routes/helpers";
import { Product } from '@lenderful/domain';

type MappedStateType = ReturnType<typeof mapStateToProps>;
type ClosingCostActions = Pick<ReduxActions, 'goToClosingCostsForm'>;
type Props = ClosingCostActions & MappedStateType;

const GoToClosingCostButtonComponent = (props: Props) => {
  const { formName, goToClosingCostsForm, hasClosingCostProduct } = props;
  const { t } = useTranslation();

  if (!hasClosingCostProduct) {
    return null;
  }

  return (
    <Grid container justifyContent='center'>
      <Grid item xs={12}>
        <Button
          classes  = {{ root: 'longButton' }}
          color    = 'primary'
          variant  = 'contained'
          onClick  = {() => goToClosingCostsForm(formName)}
        >
          {t('closingCost.button', { defaultValue: 'Get Your Estimated Closing Costs' })}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: any) => ({
  hasClosingCostProduct: productsSelector(state).some(product => product.name === Product.CLOSING_COSTS),
  formName : getFormType(state.router.location.pathname),
});

const mapDispatchToProps = FormActions;

export const GoToClosingCostButton = compose<React.ComponentType<any>>(
  connect(mapStateToProps, mapDispatchToProps),
)(GoToClosingCostButtonComponent);
